// Data fasilitas PPN berdasarkan PP 49 Tahun 2022 (sumber: Daftar_Fasilitas_PPN_PP_49_2022.pdf)
export const BKP_JKP_DATA = [
 {
  "id": 1,
  "bab": "BAB II",
  "ket": "BKP Tertentu",
  "nama": "vaksin polio dalam rangka pelaksanaan program Pekan Imunisasi Nasional dan vaksin dalam rangka penanggulangan Corona Virus Disease 2O19 (COVID- 19)",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 2,
  "bab": "BAB II",
  "ket": "BKP Tertentu",
  "nama": "buku pelajaran umum, kitab suci, dan buku pelajaran agama",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "EXISTING : PMK-5/PMK. 010/2020\n-UU No 3 tahun 2017 tentang Sistem Perbukuan Akan diatur lebih lanjut dengan PMK",
  "keterangan": ""
 },
 {
  "id": 3,
  "bab": "BAB II",
  "ket": "BKP Tertentu",
  "nama": "Barang Kena Pajak yang diterima oleh kementerian, badan, atau lembaga yang menangani bencana pada pemerintah pusat atau pemerintah daerah dalam penanganan bencana alam atau nonalam yang ditetapkan sebagai bencana nasional sesuai dengan ketentuan peraturan perundang-undangan mengenai penanggulangan bencana",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Penetapan bencana nasional sesuai dengan UU-24/2007",
  "keterangan": ""
 },
 {
  "id": 4,
  "bab": "BAB II",
  "ket": "JKP Tertentu",
  "nama": "jasa konstruksi yang diserahkan oleh kontraktor untuk pemborongan pembangunan tempat yang hanya untuk keperluan ibadah",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 5,
  "bab": "BAB II",
  "ket": "JKP Tertentu",
  "nama": "jasa konstruksi yang diserahkan oleh kontraktor untuk pembangunan bangunan yang diperuntukkan bagi korban bencana alam atau nonalam yang ditetapkan sebagai bencana nasional sesuai dengan ketentuan peraturan perundang- undangan mengenai penanggulangan bencana dan biayanya berasal dari:\n1. anggaran pendapatan dan belanja negara;\n2. anggaran pendapatan dan belanja daerah;dan/atau\n3. sumbangan",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 6,
  "bab": "BAB II",
  "ket": "JKP Tertentu",
  "nama": "Jasa Kena Pajak selain jasa konstruksi yang diterima oleh kementerian, badan, atau lembaga yang menangani bencana pada pemerintah pusat atau pemerintah daerah dalam penanganan bencana alam atau nonalam yang ditetapkan sebagai bencana nasional sesuai dengan ketentuan peraturan perundang-undangan mengenai penanggulangan bencana.",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 7,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "mesin dan peralatan pabrik yang merupakan satu kesatuan, baik dalam keadaan terpasang maupun terlepas, yang digunakan secara langsung dalam proses menghasilkan Barang Kena Pajak oleh Pengusaha Kena Pajak yang menghasilkan Barang Kena Pajak tersebut, termasuk yang atas impornya dilakukan oleh pihak yang melakukan pekerjaan konstruksi terintegrasi, tidak termasuk suku cadang;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "SKB",
  "pengajuan": "INSW",
  "pihak": "-PKP yang menghasilkan BKP\n-PKP pemilik proyek EPC\n-PKP penyedia pekerjaan EPC / Kontraktor EPC Pasal 2 PMK 115/2021",
  "aturan": "PMK 115/2021",
  "keterangan": ""
 },
 {
  "id": 8,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "barang yang dihasilkan dari kegiatan usaha di bidang kelautan dan perikanan, baik penangkapan maupun pembudidayaan, yang kriteria dan/atau perinciannya sebagaimana tercantum dalam Lampiran yang merupakan bagian tidak terpisahkan dari Peraturan Pemerintah ini",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Lampiran huruf A PP-49/2022.",
  "keterangan": ""
 },
 {
  "id": 9,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "jangat dan kulit mentah yang tidak disamak",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Kementerian Pertanian No 15/ 2021 (Ketentuan umum dan khusus untuk impor jangat&kulit mentah yg tidak disamak)",
  "keterangan": ""
 },
 {
  "id": 10,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "ternak yang kriteria dan/atau perinciannya diatur dengan Peraturan Menteri setelah mendapat pertimbangan dari menteri yang menyelenggarakan urusan pemerintahan di bidang pertanian",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PMK 5 Tahun 2016",
  "keterangan": ""
 },
 {
  "id": 11,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "bibit dan/atau benih dari barang pertanian, perkebunan, kehutanan, peternakan, atau perikanan;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Kementan, Kemen KKP, KLHK Permen-LHK-P.3/2020, Permen-KP-35/2016",
  "keterangan": ""
 },
 {
  "id": 12,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "pakan ternak sebagaimana diatur dalam ketentuan peraturan perundang-undangan di bidang peternakan dan kesehatan hewan, tidak termasuk pakan hewan kesayangan;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Kementerian Pertanian UU-18/2009 s.t.d.t.d. UU- 11/2020 jo. Permentan-22/2017",
  "keterangan": ""
 },
 {
  "id": 13,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "pakan ikan yang memenuhi persyaratan umum dan khusus/teknis dalam Impor pakan ikan sebagaimana diatur dalam ketentuan peraturan perundang-undangan di bidang perikanan",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Kemen KKP UU-31/2004 s.t.d.t.d. UU-11/2020 jo. Permen-KP-55/2018",
  "keterangan": ""
 },
 {
  "id": 14,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "bahan pakan untuk pembuatan pakan ternak dan bahan baku utama pakan ikan, tidak termasuk imbuhan pakan dan pelengkap pakan, yang kriteria dan/atau perinciannya diatur dengan Peraturan Menteri setelah mendapat pertimbangan dari menteri yang menyelenggarakan urusan pemerintahan di bidang pertanian dan menteri yang menyelenggarakan urusan pemerintahan di bidang kelautan dan perikanan",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Lampiran I dan II PMK-142/PMK.010/2017 Kementan : Permentan-57/2015, Permentan-13/2019, Kemen KKP : Permen-KP-55/2018",
  "keterangan": ""
 },
 {
  "id": 15,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "bahan baku kerajinan perak dalam bentuk perak butiran dan/atau dalam bentuk perak batangan",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PP No 81/2015",
  "keterangan": ""
 },
 {
  "id": 16,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "senjata, amunisi, helm antipeluru dan jaket atau rompi antipeluru, kendaraan darat khusus, radar, dan suku cadangnya, yang diserahkan kepada/diimpor oleh:\n1. kementerian atau lembaga pemerintah yang menyelenggarakan urusan pemerintahan di bidang pertahanan atau keamanan negara;\n2. lembaga pemerintah nonkementerian yang berkedudukan di bawah dan bertanggungjawab kepada Presiden melalui koordinasi Kepala Kepolisian Negara Republik Indonesia dan mempunyai tugas dan fungsi di bidang pencegahan dan pemberantasan penyalahgunaan dan peredaran gelap narkotika, psikotropika, dan prekursor serta bahan adiktif lainnya kecuali bahan adiktif untuk tembakau dan alkohol; atau\n3. pihak lain yang ditunjuk oleh kementerian atau lembaga pemerintah sebagaimana dimaksud dalam angka 1 atau angka 2 untuk melakukan Impor tersebut;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "SKB",
  "pengajuan": "DJP",
  "pihak": "Pihak yang melakukan impor atau pihak yag menerima penyerahan bkp strategis",
  "aturan": "KMK 370/KMK.03/2003 KEP 233/PJ/2003",
  "keterangan": "Pihak lain yang ditunjuk (No.3) hanya bisa mendapat fasilitas untuk impor saja."
 },
 {
  "id": 17,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "komponen atau bahan yang belum dibuat didalam negeri yang diimpor / komponen atau bahan yang diperoleh oleh bumn yang bergerak dalam industri pertahanan nasional yang ditunjuk oleh kementerian atau lembaga pemerintah sebagaimana dimaksud dalam huruf j angka 1 atau angka 2, yang digunakan dalam pembuatan senjata, amunisi, kendaraan darat khusus, radar, dan suku cadangnya, yang akan diserahkan kepada:\n1. kementerian atau lembaga pemerintah yang menyelenggarakan urusan pemerintahan dibidang pertahanan atau keamanan negara;atau\n2. lembaga pemerintah nonkementerian yang berkedudukan di bawah dan bertanggung jawab kepada Presiden melalui koordinasi Kepala POLRI dan mempunyai tugas dan fungsi di bidang pencegahan dan pemberantasan penyalahgunaan dan peredaran gelap narkotika, psikotropika, dan prekursor serta bahan adiktif lainnya kecuali bahan adiktif untuk tembakau dan alkohol",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "SKB",
  "pengajuan": "DJP",
  "pihak": "-Kemenhan\n-TNI\n-Polri\n-Lembaga Lain (BIN, BAKAMLA, BNN)",
  "aturan": "KMK 370/KMK.03/2003 dan Format Permohonan SKB ada di lampiran II KEP 233/PJ/2003",
  "keterangan": ""
 },
 {
  "id": 18,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "senjata, amunisi, peralatan militer, dan perlengkapan militer milik negara lain yang diimpor oleh Tentara Nasional Indonesia dalam rangka kegiatan militer sebagai bagian dari kerja sama militer berupa latihan militer bersama --> hanya impor",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 19,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "peralatan berikut suku cadangnya yang digunakan oleh kementerian yang menyelenggarakan urusan pemerintahan di bidang pertahanan atau Tentara Nasional Indonesia untuk penyediaan data batas, peta hasil topografi, peta hasil hidrografi, dan foto udara wilayah Negara Kesatuan Republik Indonesia yang dilakukan untuk mendukung pertahanan nasional, yang diserahkan kepada / diimpor oleh:\n1. kementerian yang menyelenggarakan urusan pemerintahan di bidang pertahanan;\n2. Tentara Nasional Indonesia; atau\n3. pihak yang ditunjuk oleh kementerian yang menyelenggarakan urusan pemerintahan di bidang pertahanan atau Tentara Nasional Indonesia hanya untuk melakukan impor;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "SKB",
  "pengajuan": "DJP",
  "pihak": "-Kemenhan\n-TNI",
  "aturan": "KMK 370/KMK.03/2003 dan KEP 233/PJ/2003",
  "keterangan": "Pihak yang ditunjuk (No.3) hanya bisa mendapat fasilitas untuk impor saja."
 },
 {
  "id": 20,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "kendaraan dinas khusus kepresidenan yang diimpor oleh lembaga kepresidenan atau pihak yang ditunjuk oleh lembaga kepresidenan untuk melakukan Impor, yang diberikan pembebasan Bea Masuk",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Prosedur Pembebasan Bea Masuk (PMK 191/PMK.04/2016 s t d t d PMK 91/PMK.04/2021)",
  "keterangan": "Kendaraan dinas khusus kepresidenan: helikopter, mobil kepresidenan, pesawat terbang, perlengkapan dan suku cadang"
 },
 {
  "id": 21,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "barang untuk keperluan museum, kebun binatang, dan tempat lain semacam itu yang terbuka untuk umum, serta barang untuk konservasi alam, yang diberikan pembebasan Bea Masuk",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Prosedur Pembebasan Bea Masuk (PMK 90 /PMK.04/2012)",
  "keterangan": ""
 },
 {
  "id": 22,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "barang tertentu dalam kelompok barang kebutuhan pokok yang sangat dibutuhkan oleh rakyat banyak",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Kriteria dan/atau perincian jenis barang kebutuhan pokok dalam Lampiran huruf B PP 49 2022 masih sama dengan Lampiran PMK 99 2020 (dengan penyesuaian)",
  "keterangan": "Ada beberapa penyesuaian, antara lain:\n1 .“gula konsumsi asal tebu\" menjadi BKP tertentu bersifat strategis tersendiri dalam PP 49 2022\n2. “bumbu bumbuan ( cabai) ubi ubian (ubi kayu, ubi jalar, ubi rambat, talas)\" dikelompokkan dalam komoditas sayur sayuran”\n3. “ikan segar/dingin BKTTC\" diatur sebagai BKP tertentu bersifat strategis dalam kelompok “barang hasil kelautan perikanan” dalam PP 49 2022\n4. kode HS/pos tarif objek menyelaraskan BTKI 2022"
 },
 {
  "id": 23,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "gula konsumsi dalam bentuk gula kristal putih yang berasal dari tebu tanpa tambahan bahan perasa atau pewarna;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": "Nomor HS/pos tarif yang digunakan pada saat impor gula kristal putih (plantation white sugar) yang berasal dari tebu sebagaimana dimaksud, yaitu Ex 1701 99 90"
 },
 {
  "id": 24,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "barang hasil pertambangan atau hasil pengeboran yang diambil langsung dari sumbernya, tidak termasuk hasil pertambangan batu bara, meliputi:\n1. minyak mentah (crude oil);\n2. gas bumi, berupa gas bumi yang dialirkan melalui pipa, tidak termasuk gas bumi seperti elpiji yang siap dikonsumsi langsung oleh masyarakat;\n3. panas bumi;\n4. asbes, batu tulis, batu setengah permata, batu kapur, batu apung, batu permata, bentonit, dolomit, feldspar, garam batu (halite), grafit, granit/andesit, gips, kalsit, kaolin, leusit, magnesit, mika, marmer, nitrat, obsidian, oker, pasir dan kerikil, pasir kuarsa, perlit, fosfat, talk, tanah serap (fullers earth), tanah diatom, tanah liat, tawas (alum), tras, yarosit, zeolit, basal, trakhit, dan belerang, yang batasan dan kriterianya dapat diatur dengan Peraturan Menteri; dan\n5. bijih besi, bijih timah, bijih emas, bijih tembaga, bijih nikel, bijih perak, serta bijih bauksit;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 25,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "liquified natural gas dan compressed natural gas;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "- LNG [Pasal 1 angka 5 PP 36 2004 s.t.d.d PP 30 2009]\n-CNG [Pasal 1 angka 2 Pepres 64 2012 s.t.d.d Perpres 125 2015]",
  "keterangan": ""
 },
 {
  "id": 26,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "barang yang diimpor oleh pemerintah pusat atau pemerintah daerah yang dinikmati/ dimanfaatkan untuk kepentingan umum, yang diberikan pembebasan Bea Masuk;",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Prosedur Pembebasan Bea Masuk (PMK 171 /PMK.04/20\n19)",
  "keterangan": ""
 },
 {
  "id": 27,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "obat-obatan yang diimpor dengan menggunakan anggaran pendapatan dan belanja negara atau anggaran pendapatan dan belanja daerah untuk kepentingan masyarakat, yang diberikan pembebasan Bea Masuk",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Prosedur Pembebasan Bea Masuk (PMK 102/PMK.04/2007)",
  "keterangan": ""
 },
 {
  "id": 28,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "bahan terapi manusia, pengelompokan darah, dan bahan penjenisan jaringan yang diimpor dengan menggunakan anggaran pendapatan dan belanja negara atau Ernggaran pendapatan dan belanja daerah untuk kepentingan masyarakat, yang diberikan pembebasan Bea Masuk",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Prosedur Pembebasan Bea Masuk (KMK 145/KMK. 05/1997)",
  "keterangan": ""
 },
 {
  "id": 29,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "satuan rumah susun umum milik yang perolehannya dibiayai melalui kredit/ pembiayaan kepemilikan rumah bersubsidi yang memenuhi ketentuan sebagai berikut:\n1. luas untuk setiap hunian paling sedikit 21 m2 (dua puluh satu meter persegi) dan tidak melebihi 36 m2 (tiga puluh enam meter persegi);\n2. pembangunannya mengacu kepada peraturan menteri yang menyelenggarakan urusan pemerintahan di bidang pekerjaan umum dan perumahan rakyat;\n3. merupakan unit hunian pertama yang dimiliki, digunakan sendiri sebagai tempat tinggal dan tidak dipindahtangankan dalam jangka waktu sesuai dengan ketentuan peraturan perundang-undangan di bidang rumah susun; dan\n4. batasan terkait harga jual satuan rumah susun umum milik dan penghasilan bagi orang pribadi yang memperoleh satuan rumah susun umum milik diatur oleh Menteri setelah mendapat pertimbangan dari menteri yang menyelenggarakan urusan pemerintahan di bidang pekerjaan umum dan perumahan rakyat",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PMK 115/PMK.03/2021 PMK 269/PMK.010/2015",
  "keterangan": ""
 },
 {
  "id": 30,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "rumah umum, pondok boro, asrama mahasiswa dan pelajar, serta rumah pekerja yang batasannya diatur oleh Menteri setelah mendapat pertimbangan dari menteri yang menyelenggarakan urusan pemerintahan di bidang pekerjaan umum dan perumahan rakyat",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PMK 81/PMK.010/2019",
  "keterangan": ""
 },
 {
  "id": 31,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "listrik, termasuk biaya penyambungan listrik dan biaya beban listrik, kecuali untuk rumah dengan daya di atas 6.600 (enam ribu enam ratus) voltase ampere;",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 32,
  "bab": "BAB III",
  "ket": "BKP Strategis",
  "nama": "air bersih",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 33,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa pelayanan kesehatan medis",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": "1. Untuk perorangan dan masyarakan\n2. hewan/veteriner"
 },
 {
  "id": 34,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa pelayanan sosial",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": "diselenggarakan oleh pemerintah pusat pemerintah daerah atau organisasi nirlaba"
 },
 {
  "id": 35,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa pengiriman surat dengan prangko",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 36,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa keuangan",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PMK 69 Tahun 2022; SE 121 Tahun 2010",
  "keterangan": ""
 },
 {
  "id": 37,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa asuransi",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PMK 67 Tahun 2022",
  "keterangan": ""
 },
 {
  "id": 38,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa pendidikan",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": "1. Pendidikan Sekolah jalur formal\n2. Pendidikan Luar Sekolah jalur nonformal"
 },
 {
  "id": 39,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa penyiaran yang tidak bersifat iklan",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": "-Pesan layannamasyarakat\n- pemasang iklan adalah pemerintah atau pemerintah dan badan usaha yg menbiayai dan bertanggungawab atas pesanlayanan masyarakat"
 },
 {
  "id": 40,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa angkutan umum di darat dan di air serta jasa angkutan udara dalam negeri yang menjadi bagian tidak terpisahkan dari jasa angkutan luar negeri;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PM 15/2019 (Peraturan Menteri Perhubungan)",
  "keterangan": ""
 },
 {
  "id": 41,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa tenaga kerja",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "PMK 83 Tahun 2012",
  "keterangan": ""
 },
 {
  "id": 42,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa telepon umum dengan menggunakan uang logam;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 43,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa pengiriman uang dengan wesel pos;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 44,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa persewaan rumah susun umum dan rumah umum",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "Tanpa SKB",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 45,
  "bab": "BAB IV",
  "ket": "JKP Strategis",
  "nama": "jasa yang diterima oleh kementerian yang menyelenggarakan urusan pemerintahan di bidang pertahanan atau Tentara Nasional Indonesia yang dimanfaatkan dalam rangka penyediaan data batas, peta hasil topografi, peta hasil hidrograli, dan foto udara wilayah Negara Kesatuan Republik Indonesia untuk mendukung pertahanan nasional",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Dibebaskan",
  "skb": "SKB",
  "pengajuan": "DJP",
  "pihak": "-Kemenhan\n-TNI",
  "aturan": "KMK 370/KMK.03/2003 dan KEP 233/PJ/2003",
  "keterangan": ""
 },
 {
  "id": 46,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "alat angkutan di air, alat angkutan di bawah air, alat angkutan di udara, dan kereta api, serta suku cadangnya, alat keselamatan pelayaran dan alat keselamatan manusia, dan alat keselamatan penerbangan dan alat keselamatan manusia yang diimpor oleh/diserahkan kepada kementerian atau lembaga pemerintah yang menyelenggarakan urusan pemerintahan di bidang pertahanan atau keamanan negara",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "kementerian atau lembaga pemerintah yang menyelenggaraka n urusan pemerintahan di bidang pertahanan atau keamanan negara",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 47,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "alat angkutan di air, alat angkutan di bawah air, alat angkutan di udara, dan kereta api, serta suku cadangnya, alat keselamatan pelayaran dan alat keselamatan manusia, dan alat keselamatan penerbangan dan alat keselamatan manusia yang diimpor oleh pihak lain yang ditunjuk oleh kementerian atau lembaga pemerintah yang menyelenggarakan urusan pemerintahan di bidang pertahanan atau keamanan negara untuk melakukan Impor tersebut;",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "Pihak lain yang ditunjuk",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 48,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "kapal angkutan laut, kapal angkutan sungai, kapal angkutan danau, dan kapal angkutan penyeberangan, kapal penangkap ikan, kapal pandu, kapal tunda, kapal tongkang, serta suku cadangnya, alat perlengkapan kapal, alat keselamatan pelayaran, dan alat keselamatan manusia yang diimpor dan digunakan oleh perusahaan pelayaran niaga nasional, perusahaan penangkapan ikan nasional, perusahaan penyelenggara jasa kepelabuhanan nasional, dan perusahaan penyelenggara jasa angkutan sungai, danau, dan penyeberangan nasional sesuai dengan kegiatan usahanya",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "perusahaan pelayaran niaga nasional, perusahaan penangkapan ikan nasional, perusahaan penyelenggara jasa kepelabuhanan nasional, dan perusahaan penyelenggara jasa ASDP nasional",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 49,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "pesawat udara dan suku cadangnya, alat keselamatan penerbangan dan alat keselamatan manusia, dan peralatan untuk perbaikan dan pemeliharaan yang diimpor dan digunakan oleh badan usaha angkutan udara niaga nasional",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "badan usaha angkutan udara niaga nasional",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 50,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "suku cadang pesawat udara serta peralatan untuk perbaikan dan pemeliharaan pesawat udara yang diimpor oleh pihak yang ditunjuk oleh badan usaha angkutan udara niaga nasional yang digunakan dalam rangka pemberian jasa perawatan dan perbaikan pesawat udara kepada badan usaha angkutan udara niaga nasional",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "pihak yang ditunjuk oleh badan usaha angkutan udara niaga nasional",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 51,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "kereta api dan suku cadangnya, peralatan untuk perbaikan dan pemeliharaan, dan prasarana perkeretaapian yang diimpor dan digunakan oleh badan usaha penyelenggara sarana perkeretaapian umum dan/atau badan usaha penyelenggara prasarana perkeretaapian umum ;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "badan usaha penyelenggara sarana prasarana perkeretaapian umum",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 52,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "komponen atau bahan yang diimpor oleh/diserahkan kepada pihak yang ditunjuk oleh badan usaha penyelenggara sarana perkeretaapian umum dan/atau badan usaha penyelenggara prasarana perkeretaapian umum dalam rangka pembuatan:\n1. kereta api;\n2. suku cadang;\n3. peralatan untuk perbaikan dan pemeliharaan; dan/atau\n4. prasarana perkeretaapian, yang akan digunakan oleh badan usaha penyelenggara sarana perkeretaapian umum dan/atau badan usaha penyelenggara prasarana perkeretaapian umum;",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "pihak yang ditunjuk oleh badan usaha penyelenggara sarana/prasaran a perkeretaapian umum",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 53,
  "bab": "BAB V",
  "ket": "BKP Strategis",
  "nama": "emas batangan selain untuk kepentingan cadangan devisa negara",
  "impor": true,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "",
  "keterangan": ""
 },
 {
  "id": 54,
  "bab": "BAB V",
  "ket": "JKP Strategis",
  "nama": "Pemanfaatan JKPLN : jasa persewaan pesawat udara yang dimanfaatkan oleh badan usaha angkutan udara niaga nasional.",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "badan usaha angkutan udara niaga nasional",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 55,
  "bab": "BAB V",
  "ket": "JKP Strategis",
  "nama": "jasa yang diterima oleh badan usaha angkutan udara niaga nasional, yang meliputi jasa:\n1. persewaan pesawat udara; dan\n2. perawatan dan perbaikan pesawat udara;",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "badan usaha angkutan udara niaga nasional",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 56,
  "bab": "BAB V",
  "ket": "JKP Strategis",
  "nama": "jasa yang diterima oleh perusahaan pelayaran niaga nasional, perusahaan penangkapan ikan nasional, perusahaan penyelenggara jasa kepelabuhanan nasional, dan perusahaan penyelenggara jasa ASDP nasional, yang meliputi jasa:\n1. persewaan kapal;\n2. kepelabuhanan meliputi jasa tunda, jasa pandu, jasa tambat, dan jasa labuh; dan\n3. perawatan dan perbaikan kapal;",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "perusahaan pelayaran niaga nasional, perusahaan penangkapan ikan nasional, perusahaan penyelenggara jasa kepelabuhanan nasional, dan perusahaan penyelenggara jasa ASDP nasional",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 57,
  "bab": "BAB V",
  "ket": "JKP Strategis",
  "nama": "jasa perawatan dan perbaikan kereta api yang diterima oleh badan usaha penyelenggara sarana/prasarana perkeretaapian umum",
  "impor": false,
  "penyerahan": true,
  "fasilitas": "Tidak Dipungut",
  "skb": "SKTD",
  "pengajuan": "DJP melalui e-SKTD DJP Online",
  "pihak": "badan usaha penyelenggara sarana prasarana perkeretaapian umum",
  "aturan": "PMK 41/PMK.03/2020",
  "keterangan": ""
 },
 {
  "id": 58,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang kiriman hadiah untuk keperluan ibadah umum, amal, sosial, atau kebudayaan oleh badan atau lembaga di bidang ibadah untuk umum, amal, sosial, atau kebudayaan yang:\n1. berkedudukan di wilayah Negara Kesatuan Republik lndonesia;\n2. pendiriannya sesuai dengan ketentuan peraturan perundang-undangan; dan\n3. bersifat nonprofit;",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-70/PMK.04/2012)",
  "keterangan": ""
 },
 {
  "id": 59,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang untuk keperluan penelitian dan pengembangan ilmu pengetahuan oleh:\n1. perguruan tinggi;\n2. kementerian atau lembaga pemerintah yang melaksanakan kegiatan penelitian dan/atau pengembangan ilmu pengetahuan dan teknologi; atau\n3. badan atau lembaga berbadan hukum yang melakukan kegiatan usaha dan salah satu kegiatannya melakukan penelitian atau percobaan guna peningkatan atau pengembangan ilmu pengetahuan dan teknologi sesuai dengan ketentuan peraturan perundang-undangan;",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-200/PMK. 04/2019)",
  "keterangan": ""
 },
 {
  "id": 60,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang untuk keperluan khusus penyandang disabilitas oleh badan atau lembaga sosial yang mengurus penyandang disabilitas",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (KMK-142/KMK. 05/1997)",
  "keterangan": ""
 },
 {
  "id": 61,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "peti atau kemasan lain yang berisi jenazah atau abu jenazah",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (KMK-142/KMK. 05/1997)",
  "keterangan": ""
 },
 {
  "id": 62,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang pindahan tenaga kerja Indonesia yang bekerja di luar negeri, mahasiswa yang belajar di luar negeri, pegawai negeri sipil, anggota Tentara Nasional Indonesia, atau anggota Kepolisian Negara Republik Indonesia yang bertugas di luar negeri paling singkat 1 (satu) tahun, jika barang tersebut tidak untuk diperdagangkan dan mendapat rekomendasi dari perwakilan Republik Indonesia setempat",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-28/PMK.04/2008)",
  "keterangan": ""
 },
 {
  "id": 63,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang pribadi penumpang, awak sarana pengangkut, pelintas batas, dan barang kiriman sampai batas jumlah tertentu sesuai dengan ketentuan peraturan penrndang-undangan di bidang kepabeanan;",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-199/PMK. 04/2019)",
  "keterangan": ""
 },
 {
  "id": 64,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang Impor sementara sesuai dengan ketentuan peraturan perundang-undangan mengenai Impor sementara",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-178/PMK. 04/2019)",
  "keterangan": ""
 },
 {
  "id": 65,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang yang dipergunakan oleh kontraktor kontrak kerja sama untuk:\n1. kegiatan usaha hulu minyak dan gas bumi meliputi eksplorasi dan eksploitasi; atau\n2. kegiatan penyelenggaraan panas bumi untuk pemanfaatan tidak langsung yang meliputi penugasan survei pendahuluan dan eksplorasi, eksplorasi, eksploitasi, dan pemanfaatan;",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk",
  "keterangan": ""
 },
 {
  "id": 66,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang yang telah diekspor kemudian diimpor kembali dalam kualitas yang sama dengan kualitas pada saat diekspor",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk",
  "keterangan": ""
 },
 {
  "id": 67,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang yang telah diekspor untuk keperluan perbaikan, pengerjaan, dan pengujian, kemudian diimpor kembali",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk",
  "keterangan": ""
 },
 {
  "id": 68,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang dan bahan untuk diolah, dirakit, atau dipasang pada barang lain yang mendapat kemudahan Impor untuk tujuan ekspor",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-149/PMK. 04/2022)",
  "keterangan": ""
 },
 {
  "id": 69,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang dan bahan atau mesin yang diimpor oleh usaha atau industri mikro, kecil, dan menengah atau konsorsium untuk usaha atau industri mikro, kecil, dan menengah dengan menggunakan kemudahan Impor untuk tujuan ekspor",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-177/PMK.04/2016 s.t.d.d. PMK-110/PMK. 04/2019)",
  "keterangan": ""
 },
 {
  "id": 70,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang dalam rangka perjanjian kerjasama/karya pengusahaan pertambangan batubara yang dilakukan oleh kontraktor perjanjian kerja sama/karya pengusahaan pertambangan batubara dengan ketentuan sebagai berikut:\n1. kontraknya ditandatangani sebelum tahun 1990;\n2. kontraknya mencantumkan ketentuan mengenai pemberian pembebasan atau keringanan Bea Masuk atas Impor barang dalam rangka perjanjian kerja sama/karya pengusahaan pertambangan batubara;\n3. kontraknya tidak mencantumkan ketentuan mengenai jangka waktu pemberian pembebasan atau keringanan Bea Masuk; dan\n4. barang impornya merupakan barang milik negara;",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk",
  "keterangan": ""
 },
 {
  "id": 71,
  "bab": "BAB VI",
  "ket": "BKP bebas BM",
  "nama": "barang kiriman hadiah/hibah untuk kepentingan penanggulangan bencana alam yang diajukan oleh:\n1. badan atau lembaga yang bergerak di bidang ibadah untuk umum, amal, sosial, atau kebudayaan;\n2. pemerintah pusat dan pemerintah daerah; atau\n3. lembaga internasional atau lembaga asing nonpemerintah.",
  "impor": true,
  "penyerahan": false,
  "fasilitas": "Tidak Dipungut",
  "skb": "Tanpa SKTD",
  "pengajuan": "",
  "pihak": "",
  "aturan": "Mengikuti Ketentuan Pembebasan Bea Masuk (PMK-69/PMK.04/2012)",
  "keterangan": "x"
 }
];
